import InstitutionBusinessProfileForm from '@/features/institution/business-profile/components/form';
import InstitutionDetailsLayout from '@/features/institution/layouts/details';
import { INSTITUTION_DETAILS_TYPE } from '@/features/institution/utils';

const InstitutionOnboardingBusinessProfilePage = () => {
  return (
    <InstitutionDetailsLayout detailsKey="businessProfile" detailsType={INSTITUTION_DETAILS_TYPE.ONBOARDING}>
      <InstitutionBusinessProfileForm />
    </InstitutionDetailsLayout>
  );
};
InstitutionOnboardingBusinessProfilePage.displayName = 'InstitutionOnboardingBusinessProfilePage';

export default InstitutionOnboardingBusinessProfilePage;
